export default "__VITE_ASSET__BszaBD2Z__"